var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.875C8.5293 0.875 11 3.3457 11 6.375C11 9.42578 8.5293 11.875 5.5 11.875C2.44922 11.875 0 9.42578 0 6.375C0 3.3457 2.44922 0.875 5.5 0.875ZM5.5 10.8438C7.94922 10.8438 9.96875 8.8457 9.96875 6.375C9.96875 3.92578 7.94922 1.90625 5.5 1.90625C3.0293 1.90625 1.03125 3.92578 1.03125 6.375C1.03125 8.8457 3.0293 10.8438 5.5 10.8438ZM6.35938 8.09375C6.63867 8.09375 6.875 8.33008 6.875 8.60938C6.875 8.91016 6.63867 9.125 6.35938 9.125H4.64062C4.33984 9.125 4.125 8.91016 4.125 8.60938C4.125 8.33008 4.33984 8.09375 4.64062 8.09375H4.98438V6.71875H4.8125C4.51172 6.71875 4.29688 6.50391 4.29688 6.20312C4.29688 5.92383 4.51172 5.6875 4.8125 5.6875H5.5C5.7793 5.6875 6.01562 5.92383 6.01562 6.20312V8.09375H6.35938ZM5.5 5C5.11328 5 4.8125 4.69922 4.8125 4.3125C4.8125 3.94727 5.11328 3.625 5.5 3.625C5.86523 3.625 6.1875 3.94727 6.1875 4.3125C6.1875 4.69922 5.86523 5 5.5 5Z",
    fill: "#E8B34F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.4ab6d94b9a5072cf99cdaeafb35c8938.svg";
export { ForwardRef as ReactComponent };